import updateDesign from './updateDesign';
import { getProductParentIdEntry } from './utils';

export default async (set, get, host, designId, updatedAccessories, cabinetInfo) => {
  try {
    const updatedDesign = {
      Cart: updatedAccessories,
      ProductParentIds: getProductParentIdEntry(cabinetInfo?.itemId, cabinetInfo?.parentId)
    };

    set(
      updateDesign(set, get, host, designId, updatedDesign),
      false,
      { type: 'cabinetVisualizer/updateDesignAccessories' }
    );
  } catch (err) {
    console.error(`Update Cabinet Design Error: ${err}`);
  }
};